// extracted by mini-css-extract-plugin
module.exports = {"varFontSize100":"var(--tkww-union-typography-scale-100-font-size, 0.75rem)","combinedDropdown":"combinedDropdown--67784","sectionHeader":"sectionHeader--bba1f"};